import * as Yup from "yup";

const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{12,}$/;

export const resetPasswordValidationSchema = Yup.object({
  password: Yup.string()
    .required("Password is required")
    .matches(
      passwordRegex,
      "Password must contain at least 12 characters, including one upper case, one number and one special character"
    )
    .min(12, "Password must be at least 12 characters long"),
  passwordConfirm: Yup.string()
    .required("Confirm Password is required")
    .matches(
      passwordRegex,
      "Password must contain at least 12 characters, including one upper case, one number and one special character"
    )
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .min(12, "Confirm Password must be at least 12 characters long"),
});
